var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapPolygon',{attrs:{"paths":_vm.paths,"options":_vm.options},on:{"click":function($event){return _vm.$emit("click")}}})
}
var staticRenderFns = []

export { render, staticRenderFns }